import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

function Login({ setIsLoggedIn }) {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleSignin = (e) => {
    e.preventDefault();
    if (!email.trim()) {
      setErrorMessage("Email is required");
      return;
    }
    if (!password.trim()) {
      setErrorMessage("Password is required");
      return;
    }

    axios
      .post(process.env.REACT_APP_APIURL + "admin/login", { email_address: email, password })
      .then((res) => {
        if (res.data.status === "success") {
          window.localStorage.setItem("email_address", email);
          window.localStorage.setItem("user_id", email);
          window.localStorage.setItem("signup", res.data.result.signup);
          if (res.data.result.signup === "user") {
            window.localStorage.setItem("business_id", email);
          }
          setSuccessMessage("User logged in successfully.");
          setIsLoggedIn(true);

          setTimeout(() => {
            navigate("/businesses");
          }, 2000); // Delay navigation for 2 seconds
        } else {
          if (res.data.error && res.data.error.message) {
            setErrorMessage(res.data.error.message);
          } else {
            setErrorMessage("An error occurred during login");
          }
        }
      })
      .catch((err) => {
        console.error("Login error:", err);
        setErrorMessage("The email or password you entered is incorrect.");
      });
  };

  return (
    <div className="login-box login_div">
      <div className="card card-outline card-primary">
        <div className="card-header text-center">
          <a href="#" className="login_logo">
            <img src="assets/img/logo.png" border={0} alt="Logo" />
          </a>
        </div>
        <div className="card-body d-flex flex-row flex_flow_rowwrap">
          <div className="col-12 col-sm-12 col-md-12">
            <h5 className="login-box-msg mb-3">Admin Login</h5>

            {successMessage && (
              <div className="alert alert-success alert-dismissible fade show" role="alert">
                {successMessage}
                <button type="button" className="close" onClick={() => setSuccessMessage("")} aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            )}
            {errorMessage && (
              <div className="alert alert-danger alert-dismissible fade show" role="alert">
                {errorMessage}
                <button type="button" className="close" onClick={() => setErrorMessage("")} aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            )}

            <form onSubmit={handleSignin}>
              <div className="input-group mb-3">
                <input
                  type="email"
                  className="form-control"
                  placeholder="Username"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <div className="input-group-append">
                  <div className="input-group-text">
                    <i className="fa-solid fa-user" />
                  </div>
                </div>
              </div>
              <div className="input-group mb-3">
                <input
                  type="password"
                  className="form-control"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <div className="input-group-append">
                  <div className="input-group-text">
                    <i className="fas fa-lock" />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12 mt-3">
                  <button type="submit" className="btn btn-primary btn-block">
                    Login
                  </button>
                </div>

                {/* <div class="col-12 mt-3" style={{ paddingLeft: '200px' }}>
                  <p >Don't have an account?<a href="/signup" style={{ paddingLeft: '5px' }}>sign up</a> </p>
                </div> */}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
